export default __webpack_public_path__ + "static/media/screen2.0f3d930b.png";